import dayjs from 'dayjs';

export const getStartEndIsoDate = (date: Date | null | undefined, time: 'start' | 'end') => {
  if (!date) return '';
  if (date.toString() === 'Invalid Date') return 'invalid_date';

  try {
    const day = dayjs(date);
    return time === 'start'
      ? day.startOf('day').format('YYYY-MM-DDTHH:mm:ss')
      : day.endOf('day').format('YYYY-MM-DDTHH:mm:ss');
  } catch (error) {
    console.error(error);
    return '';
  }
};
